import store, {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import {FORCE_CLOSE, SHOW_ERROR} from '@/common/store/modules/enrolment/response.js';
import {ERROR_TYPE} from '@/iamteacherpc/consts/errorType.js';
import {createApi} from "@common/apis/api.js";

const api = createApi();

api.interceptors.response.use(
    data => data,
    error => {
        const errorType = Object.keys(store.state[ENROLMENT_RESPONSE_NAMESPACE].survey).length === 0 ? ERROR_TYPE.FULL_SCREEN : ERROR_TYPE.POPUP;

        // 종료된 수강신청은 걍 리로드 시켜버린다.
        if (errorType === ERROR_TYPE.POPUP && error.code === 260011/*종료된 수강신청*/) {
            store.dispatch(`${ENROLMENT_RESPONSE_NAMESPACE}/${FORCE_CLOSE}`);
        }

        // 페이지 접속 이후 수강신청이 삭제된 설문은 강제로 리로드한다.
        if (errorType === ERROR_TYPE.POPUP && error.code === 260021/*삭제된 수강신청*/) {
            window.onbeforeunload = null;
            window.location.reload();
            return;
        }

        store.dispatch(`${ENROLMENT_RESPONSE_NAMESPACE}/${SHOW_ERROR}`, {
            hasError: true,
            errorType: errorType,
            resultCode: error.code,
            resultMessage: error.message,
        });

        return Promise.reject(error);
    }
);

/**
 * 수강신청 전체 정보조회
 * @param payload
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getEnrolmentsAnswers(payload) {
    return api.get('enrolments/answers', {
        params: {
            surveyReferenceNo: payload.surveyReferenceNo,
            receiverReferenceNo: payload.receiverReferenceNo,
            provider: payload.provider,
            isMasking: payload.isMasking
        }
    });
}

/**
 * 프로그램 신청
 * @param payload
 * @returns {Promise<AxiosResponse<T>>}
 */
export function postEnrolmentAnswer(payload) {
    return api.post(`enrolments/${payload.surveyNo}/answers`, {
        surveyReferenceNo: payload.data.surveyReferenceNo,
        questionNo: payload.data.questionNo,
        surveyReceiverNo: payload.data.surveyReceiverNo,
        isFCFS: payload.data.isFCFS,
        answerNo: 0,
        answer: 1
    })
}

/**
 * 프로그램 신청 취소
 * @param payload
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteEnrolmentAnswer(payload) {
    return api.delete(`enrolments/${payload.surveyNo}/answers/${payload.surveyAnswerNo}`, {
        data: {surveyReceiverNo: payload.surveyReceiverNo}
    })
}

/**
 * 프로그램 단건 조회
 * @param surveyNo
 * @param questionNo
 * @param receiverNo
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getProgramAnswer({surveyNo, questionNo, receiverNo}) {
    return api.get(`enrolments/${surveyNo}/questions/${questionNo}/receivers/${receiverNo}`);
}

/**
 * 프로그램 전체 취소
 * @param surveyNo
 * @param surveyReceiverNo
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteAllAnswers({surveyNo, surveyReceiverNo}) {
    return api.delete(`enrolments/${surveyNo}/answers`, {
        data: {surveyReceiverNo: surveyReceiverNo}
    });
}
